import React from 'react';
import { CollectionHeader } from '../ContentCollection';
import styles from './AdditionalMaterials.scss';

const AdditionalMaterials = props => {
  const { items, title: sectionTitle, description: sectionDescription } = props;

  return (
    <div className="AdditionalMaterials">
      <CollectionHeader title={sectionTitle} />
      {sectionDescription && (
        <div>
          <p>{sectionDescription}</p>
        </div>
      )}
      {items &&
        items.map(({ title, description, imageUrl, url }) => {
          return (
            <div className="AdditionalMaterials__Row" key={title || imageUrl}>
              {imageUrl && (
                <div className="AdditionalMaterials__Row__Thumbnail">
                  <a href={url} target="blank">
                    <img alt={title} src={imageUrl} />
                  </a>
                </div>
              )}
              <div className="AdditionalMaterials__Row__Text">
                {title && <h3>{title}</h3>}
                <p>{description}</p>
                {url && (
                  <div>
                    <a
                      className="AdditionalMaterials__Row__Link"
                      href={url}
                      target="blank"
                    >
                      View
                    </a>
                  </div>
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default AdditionalMaterials;
